import React, { useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import ChartComponent from './ChartComponent';
import { AiOutlineAreaChart } from 'react-icons/ai';
import { FaNewspaper } from 'react-icons/fa';

import './Stock.css';
import NewsComponent from './NewsComponent';

const Stock = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { symbol } = useParams() || 'N/A';
  const companyData = location.state?.companyData;
  const companyPrice = location.state?.companyPrice;
  const priceHistory = location.state?.priceHistory;
  const companyNews = location.state?.companyNews;

  useEffect(() => {
    if (!companyData) {
      navigate('/');
    }
  }, [companyData, navigate]);

  return (
    companyData && (
      <div className="stock-container text-primary">
        <div className="stock-parent">
          <div className="stock-info">
            <div className="space-between">
              <h1 className="heavy">
                {companyData['Name']} - {symbol.toUpperCase()}
              </h1>
              <h2>${Number(companyPrice['05. price']).toFixed(2)}</h2>
            </div>
            <div className="bottom-space-small description">
              <h5>{companyData['Description']}</h5>
            </div>
            <div className="bottom-space-small space-between">
              <h3>Market Cap:</h3>
              <h3>
                {Number(companyData['MarketCapitalization'])
                  .toLocaleString('en-US', {
                    style: 'currency',
                    currency: `${companyData['Currency']}`,
                  })
                  .replace(/\.\d+$/, '')}
              </h3>
            </div>
            <div className="bottom-space-small space-between">
              <h3>P/E:</h3>
              <h3>{companyData['PERatio']}</h3>
            </div>
            <div className="bottom-space-small space-between">
              <h3>Forward P/E:</h3>
              <h3>{companyData['ForwardPE']}</h3>
            </div>
            <div
              className={`space-between ${
                companyData['DividendYield'] > 0
                  ? 'bottom-space-small'
                  : 'top-space-small'
              }`}
            >
              <h3>EPS:</h3>
              <h3>{companyData['EPS']}</h3>
            </div>
            {companyData['DividendYield'] > 0 && (
              <div className="space-between top-space-small">
                <h3>Dividend Yield: </h3>
                <h3>
                  {(parseFloat(companyData['DividendYield']) * 100).toFixed(2)}%
                </h3>
              </div>
            )}
          </div>

          <div className="stock-charts">
            {priceHistory && (
              <>
                <h1 className="heavy" style={{ display: 'flex' }}>
                  <AiOutlineAreaChart className="icon" /> Price History
                </h1>
                <ChartComponent priceHistory={priceHistory}></ChartComponent>
              </>
            )}
          </div>
        </div>

        {companyNews.length > 1 && (
          <div className="stock-news">
            <>
              <h1 className="heavy" style={{ display: 'flex' }}>
                <FaNewspaper className="icon" /> News
              </h1>
              <div className="news-carousel">
                {companyNews.map((item) => (
                  <NewsComponent
                    title={item.title}
                    image={item.banner_image}
                    url={item.url}
                    key={item.id}
                  ></NewsComponent>
                ))}
              </div>
            </>
          </div>
        )}
      </div>
    )
  );
};

export default Stock;
